import axios from "axios";

// Auth is a server-side device session in an httpOnly cookie (Phase 5); nothing is kept in localStorage.
localStorage.removeItem("dls_token");
export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`, withCredentials: true });
const AUTH_STEPS = ["/auth/login", "/auth/verify", "/auth/resend", "/auth/me"];

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && !AUTH_STEPS.some((p) => err.config?.url?.includes(p))) {
      window.dispatchEvent(new Event("dls:logout"));
    }
    return Promise.reject(err);
  }
);

export function errMsg(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d?.msg || JSON.stringify(d)).join(" ");
  return detail.msg || String(detail);
}
